import Holidays from 'date-holidays'
import { HolidayType } from '../types/holidays'

export interface IDateHolidaysHoliday {
  date: string
  start: Date
  end: Date
  name: string
  rule: string
  type: string
  note?: string
}

interface Options {
  timezone?: string
  languages?: string[]
  types?: HolidayType[]
}

export class PublicHolidaysRepository {
  
  private holidays: Holidays
  private options: Options

  constructor(locale?: string, timezone?: string) {
    this.options = {
      timezone,
      languages: [locale ?? 'en'],
    }
    this.holidays = new Holidays(this.options)
  }

  getHolidaysForCountry(year: number, countryCode: string, stateCode?: string, type?: string): IDateHolidaysHoliday[] {
    const typeOptions: Partial<Options> = {
      types: type ? ([type] as HolidayType[] ): undefined,
    }
    this.holidays.init(countryCode, stateCode, {...typeOptions, ...this.options})    
    return this.holidays.getHolidays(year)
  }

  getCountries() {
    const countries = this.holidays.getCountries()
    return Object.entries(countries).map(([id, name]) => ({ id, name }))
  }

}
